/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-05 10:51:42
 * @LastEditTime: 2022-01-10 16:11:29
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 人工对账
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/ReconciliationList/components/ManualCheck.jsx
 */
import { Form, message, Modal } from 'antd';
import React, { useState, useRef } from 'react'
import { fetchPlatformRecordManualReconciliation } from '../../../../services/platformAccountingRecord';
import TextArea from 'antd/lib/input/TextArea';
import DetailTitle from "../../../../components/DetailTitle";
import FileUpload from "../../../../components/FileUpload";

const PlatformManualCheckModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [upload, setUpload] = useState(true);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    let monitor = useRef(null)
    const open = (ids) => {
        if(ids.length==1) {
            setUpload(true)
            if (this.fileUploadRef) {
                this.fileUploadRef.setFileToState([]);
            }
        }else{
            setUpload(false)
        }
        setVisible(true)
        setFormData({ids})
        return new Promise((resolve, reject) => {
            monitor.current = resolve
        })
    }
    const close = () => {
        setVisible(false)
        if( this.fileUploadRef){
            this.fileUploadRef.setFileToState([]);
        }
    }



    const postSubmit = () => {
        setLoading(true)
        if(this.fileUploadRef) {
            formData.attachIds = this.fileUploadRef.parseAttachToIds()
        }
        return fetchPlatformRecordManualReconciliation(formData).then(res => {
            message.success('对账成功')
        }).finally(() => {
            setLoading(false)
        })
    }



    const handleChange = (data) => {
        setFormData({...formData, ...data})
    }

    const handleSubmit = () => {
        if (!formData.note) {
            return message.warning('请输入银行流水信息')
        }
        postSubmit().then(() => {
            close()
            monitor.current()
        })
    }

    props.getRef && props.getRef({ open })

    return (
        <Modal title="手动对账" visible={visible} onCancel={close} onOk={handleSubmit} confirmLoading={loading} >
            <Form layout="vertical" style={{ padding: 20 }}>
                <DetailTitle title="银行流水信息" />
                <TextArea value={formData.note} onChange={e => handleChange({note: e.target.value})} style={{minHeight:150}} placeholder="请输入银行流水信息" />
                {upload?<DetailTitle title="银行回执信息附件" />:null}
                {upload? <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="tradeRecord"  fileTypeList={[18]} isValueStyle={true}/>:null
                }

            </Form>
        </Modal>
    )
}

export default PlatformManualCheckModal


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/ReconciliationList/components/ManualCheck.jsx